export const LayoutServiceConfig = (env: string) => {
  const url =
    env === 'production'
      ? 'https://website-utility.cleartax.in'
      : 'https://website-utility-qa-http.internal.cleartax.co';
  return {
    apiUrl: url + '/api/layout/',
  };
};



// WEBPACK FOOTER //
// ./constants/layoutServiceConst.ts